import { state } from '@/store/configuration/state';
import { actions } from '@/store/configuration/actions';
import { mutations } from '@/store/configuration/mutations';
import { getters } from '@/store/configuration/getters';

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};

export { state, mutations, actions, getters };
